import { Twitter, Linkedin, Github, Mail } from "lucide-react";
import { useTheme } from "../../../../context/ThemeContext";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const { isDarkTheme } = useTheme();
  const navigate = useNavigate();

  const handleClick = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id.toLowerCase());
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const handleContactClick = () => {
    navigate('/contact');
  };

  const handlePrivacyPolicyClick = () => {
    navigate('/privacy-policy');
  };

  return (
    <footer className={`${isDarkTheme ? 'bg-dark-background' : 'bg-[#262626]'} text-gray-300 py-12 px-4 md:px-8`}>
      <div className="max-w-7xl mx-auto">
        {/* Grid Layout with equal spacing */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-8 md:gap-8 mb-8">
          {/* Social Handles */}
          <div className="space-y-3">
            <h4 className="text-white font-semibold mb-2">Connect With Us</h4>
            <div className="flex gap-4">
              <a href="https://www.linkedin.com/" className="hover:text-white transition-colors" target="_blank">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://github.com/" className="hover:text-white transition-colors" target="_blank">
                <Github className="w-5 h-5" />
              </a>
              <a href="https://gmail.com/" className="hover:text-white transition-colors" target="_blank">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="space-y-3">
            <h4 className="text-white font-semibold mb-2">Navigation</h4>
            <nav className="flex flex-col gap-2">
              {['Hero', 'Services', 'Workflow', 'Benefits', 'FAQs'].map((item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase()}`}
                  onClick={(e) => handleClick(e, item)}
                  className="hover:text-white transition-colors text-sm cursor-pointer"
                >
                  {item}
                </a>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div className="space-y-3 mt-8 md:mt-0">
            <h4 className="text-white font-semibold mb-2">Services</h4>
            <div className="flex flex-col gap-2">
              {['Drilling', 'Reservoir', 'Manufacturing'].map((service) => (
                <a
                  key={service}
                  href="#"
                  className="hover:text-white transition-colors text-sm"
                >
                  {service}
                </a>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div className="space-y-3 mt-8 md:mt-0">
            <h4 className="text-white font-semibold mb-2">Legal</h4>
            <div className="flex flex-col gap-2">
              <button
                onClick={handlePrivacyPolicyClick}
                className="hover:text-white transition-colors text-sm text-left cursor-pointer"
              >
                Privacy Policy
              </button>
              {['Terms of Service'].map((item) => (
                <a
                  key={item}
                  href="#"
                  className="hover:text-white transition-colors text-sm"
                >
                  {item}
                </a>
              ))}
              <button
                onClick={handleContactClick}
                className="hover:text-white transition-colors text-sm text-left"
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="border-t border-gray-700 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © 2025 All rights reserved. Developed by <a href="https://www.devairo.com/" target="_blank">Devairo</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;